<template>
  <div>
    <page-title>Port Guide</page-title>
  </div>
</template>

<script>
export default {
  name: "port-guide"
};
</script>
